import { DialogRoot } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/DialogRoot'
import { DialogForm } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/DialogForm'
import { DialogButtons } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/DialogButtons'
import { DialogFormField } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/DialogFormField'
import { DialogConsent } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/Consent/DialogConsent'
import { DialogConsentForm } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/Consent/DialogConsentForm'
import { DialogConsentSummary } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/Consent/DialogConsentSummary'
import { DialogConsentReconfirm } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/Consent/Reconfirm/DialogConsentReconfirm'
import { DialogConsentDinas } from 'app/KinerjaKSPage/components/CardDataConfirmation/Dialog/Consent/Dinas/DialogConsentDinas'

const Dialog = {
  Root: DialogRoot,
  Buttons: DialogButtons,

  // Form
  Form: DialogForm,
  FormField: DialogFormField,

  // Consent
  Consent: DialogConsent,
  ConsentForm: DialogConsentForm,
  ConsentSummary: DialogConsentSummary,

  // Consent for Penilaian oleh Dinas
  ConsentDinas: DialogConsentDinas,

  // Consent for Konfirmasi Ulang
  ConsentReconfirm: DialogConsentReconfirm,
}

export default Dialog
